import "./Background.scss";

import { FCC } from "types";

export const Background: FCC = ({ children }) => (
  <div id="app-background">{children}</div>
);
